const finite = value => Number.isFinite(value)

export const calculateAutocompleteMaxHeight = ({
  listTop,
  bottomBoundary,
  visualViewportBottom,
  layoutViewportBottom,
  editorHeight = 0,
  gap = 6
}) => {
  if (!finite(listTop)) {
    return 0
  }

  let availableBottom = bottomBoundary
  if (finite(availableBottom) && finite(layoutViewportBottom)) {
    availableBottom = Math.min(availableBottom, layoutViewportBottom)
  }
  if (!finite(availableBottom)) {
    if (!finite(visualViewportBottom)) {
      return 0
    }
    availableBottom = visualViewportBottom - (finite(editorHeight) ? editorHeight : 0)
  }

  return Math.max(0, Math.floor(availableBottom - listTop - gap))
}

export const isSoftKeyboardOccludingViewport = ({
  layoutViewportHeight,
  visualViewportBottom,
  threshold = 100
}) => {
  if (!finite(layoutViewportHeight) || !finite(visualViewportBottom)) {
    return false
  }
  return layoutViewportHeight - visualViewportBottom > threshold
}
